import { render, staticRenderFns } from "./MisOrdenesIndex.vue?vue&type=template&id=3a631d2a&scoped=true&"
import script from "./MisOrdenesIndex.vue?vue&type=script&lang=js&"
export * from "./MisOrdenesIndex.vue?vue&type=script&lang=js&"
import style0 from "./MisOrdenesIndex.vue?vue&type=style&index=0&id=3a631d2a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a631d2a",
  null
  
)

export default component.exports